import React from 'react';
import Icon_Back from "../../assets/svgs/Icon_Back.svg";

import { ProductData } from "../../data/product.data"

export default function GalleryView({ scenario, product, setProduct, productCategory, setMenuView }: any) {

  const [roofList, setRoofList] = React.useState([]);

  React.useEffect(() => {
    
    if (scenario) {
      var roof_list: any = [];
      var roofProducts: any = ProductData()

      for (let productInfo of roofProducts) {
        if (productInfo.active === true){ //&& scenario.productsRoof.includes(product.id))
          productInfo.available = productCategory === 'roof' ? scenario.productsRoof.includes(productInfo.id) : scenario.productsFacade.includes(productInfo.id);
          roof_list.push(productInfo)
        }
      }
      setRoofList(roof_list)
    }
  }, [scenario, productCategory]);

  

  return (
    <div className="gallery-container">

      {/* PRODUCTS */}
      <div className={`gallery-list-grid`}>
        { roofList.map((productIter: any, index) =>
          <div key={index} className={`gallery-list-button ${productIter.id === product.id ? 'selected' : ''} ${productIter.available === true &&  productIter.interactable === true ? '' : 'disabled'}`} onClick={() => setProduct(productIter)}>
            <div className={`gallery-list-button-text ${productIter.available === true &&  productIter.interactable === true ? '' : 'disabled'}`}>
              {productIter.name}
            </div>
          </div>
        )}
      </div>
      <div className="gallery-button" onClick={() => setMenuView("PERSONALIZA")}>
        <img className={`gallery-button-icon`} style={{transform: `rotate(90deg)`}} src={Icon_Back} alt=''/>
        <div className="gallery-button-text">
          Cerrar Galería
        </div>
      </div>

    </div>
  );
}
